<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  created() {
    this.initBrand();
    this.getCityGeolocation();
  },
  computed: {
    ...mapState('user', ['uid']),
  },
  watch: {
    uid: {
      handler() {
        this.inviteFriend();
      },
      immediate: true,
    },
  },
  mounted() {
    const shareData = {
      title: '圣诞拆礼盒',
      desc: '集齐必中88元现金红包',
      link: `${window.location.origin}${process.env.VUE_APP_BASE_URL}/index`,
      imgUrl: 'https://w-cdn.pangku.com/uploads/alipay/default/2020121112053909462471794991.jpg',
    };
    this.generateShareLink(shareData);
  },
  methods: {
    ...mapActions('brand', ['initBrand']),
    ...mapActions('city', ['getCityGeolocation']),
    ...mapActions('shareLink', ['generateShareLink']),
    ...mapActions('user', ['inviteFriend']),
  },
};
</script>
